import Component from 'flarum/common/Component';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
export default class ForumNav extends Component {
  view() {
    return m("div", {
      className: "BlogForumNav BlogSideWidget"
    }, m("h3", null, app.translator.trans('v17development-flarum-blog.forum.forum_nav')), m("nav", {
      className: "IndexPage-nav sideNav"
    }, m(SelectDropdown, {
      buttonClassName: "Button",
      className: "App-titleControl"
    }, this.navItems().toArray())));
  }
  navItems() {
    return IndexSidebar.prototype.navItems.call(this);
  }
}
flarum.reg.add('v17development-blog', 'forum/components/ForumNav', ForumNav);